import { TAGS, api } from "@/store/api"
import { IPaginationReq, IPaginationRes } from "@/types"
import {
  IGetPersonalDeckInventoryCountsResponse,
  IPersonalDeckCard
} from "./personalDeck.types.ts"

const basePath = "/personal-deck"

export const personalDeckApi = api.enhanceEndpoints({
  addTagTypes: [TAGS.PERSONAL_DECK]
})

export const personalDeckEndpoints = personalDeckApi.injectEndpoints({
  endpoints: (builder) => ({
    getPersonalDeckInventory: builder.query<
      IPaginationRes<IPersonalDeckCard>,
      IPaginationReq
    >({
      query: (params) => ({
        url: `${basePath}/inventory`,
        method: "GET",
        params
      }),
      providesTags: () => [{ type: TAGS.PERSONAL_DECK, id: "INVENTORY" }]
    }),
    getPersonalDeckInventoryCounts: builder.query<
      IGetPersonalDeckInventoryCountsResponse,
      void
    >({
      query: (params) => ({
        url: `${basePath}/inventory/counts`,
        method: "GET",
        params
      }),
      providesTags: () => [{ type: TAGS.PERSONAL_DECK, id: "INVENTORY_COUNTS" }]
    })
  })
})

export const {
  useGetPersonalDeckInventoryCountsQuery,
  useGetPersonalDeckInventoryQuery
} = personalDeckEndpoints
